'use strict';

var baseUrl = require('./baseUrl.js');
var log = require('loglevel');

function loadError(url, err) {
	log.error('Failed to load script "'+ url +'". Error:', err);
}

function loadScript(url, onload) {
	var elem = document.createElement('script');
	elem.src = baseUrl(url);
	if (onload !== undefined) {
		elem.onload = onload;
	}
	elem.onerror = loadError.bind(this, url);
	document.body.appendChild(elem);
}

module.exports = loadScript;